import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const cloudmigrationicon = "/assets/icons/cloud_migration icon.png";
const backupsolutionicon = "/assets/icons/backup_solution icon.png";
const cloudsecurity = "/assets/icons/cloud security.png";
const devopsicon = "/assets/icons/devops_icon.png";


const CloudSolution = () => {
  useEffect(() => {
    document.title = 'Cloud Solutions | Inypeople';
  }, []);


  return (
    <>
      <section className="web-dev-section cloud-solution-page">
        <div className="web-dev-container">
          <h1 className="web-dev-title">Cloud Solutions</h1>

            <p className="cloud-solution-description">
            At Inypeople, we help businesses leverage the power of the cloud through comprehensive, secure, and scalable cloud solutions. Our services enable seamless adoption, optimized performance, and cost efficiency across modern cloud environments.
            <br />
            <br />
            From cloud strategy and migration to management and optimization, we ensure your infrastructure supports agility and innovation. With a focus on reliability and security, our cloud solutions empower organizations to scale faster and operate with confidence.
          </p>
        </div>

        <div className="circle circle-left"></div>
        <div className="circle circle-right"></div>
        <div className="circle circle-right-top"></div>
        <div className="circle circle-left-bottom"></div>
      </section>

      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">Drive better engagement with innovative cloud services.</h2>

          <div className="services-grid">
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={cloudmigrationicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Cloud Migration & Deployment</h3>
                </div>

                <p className="service-description">
                  Seamlessly migrate your applications and data to the cloud with minimal disruption. Our solutions ensure secure, scalable, and optimized deployments. Enable faster access, performance, and business continuity.
                </p>
              </div>
            </div>

            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={backupsolutionicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Disaster Recovery & Backup Solutions</h3>
                </div>
                <p className="service-description">
                  Ensure business continuity with reliable backup and disaster recovery strategies. Protect critical data and applications from unexpected disruptions. Minimize downtime and maintain operational resilience.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={cloudsecurity}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Cloud Security & Compliance</h3>
                </div>
                <p className="service-description">
                  Protect your cloud infrastructure with robust security measures and regulatory compliance. Safeguard data, applications, and workloads from threats. Maintain trust and operational integrity across all platforms.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={devopsicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">DevOps & Cloud Automation</h3>
                </div>
                <p className="service-description">
                  Accelerate software delivery and operational efficiency with DevOps practices and cloud automation. Streamline workflows, reduce errors, and enhance scalability. Enable continuous integration and continuous deployment with confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Add GetInTouch at the bottom of this service page */}
      <GetInTouch />
    </>
  );
};

export default CloudSolution;
